import type { PathItem } from '@mimir/primitive/pathItem';
import type { SearchResultHit } from '@mimir/common/dto/searchResultHit';
import { requestDialog } from './requestDialog';
import type { ImportFolderDialogRequest } from './importFolderDialogRequest';

/**
 * Shows the ImportFolderDialog, for when starting a folder import
 * to Premiere. Returns a Promise that resolves when
 * the import is finished, either by being cancelled, completed or failed,
 * allowing the UI to clear any associated loading state
 */
export function showImportFolderDialog(
  folder: {id: string, name: string },
  folderPath: PathItem[],
  loadedItems: SearchResultHit[] = []
): Promise<void> {
  return new Promise(resolve => {
    const req: ImportFolderDialogRequest = {
      loading: true,
      showDialog: true,
      onDone: () => resolve(),
      folder,
      folderPath,
      loadedItems,
    };
    requestDialog(req, () => import('@mimir/web/components/Common/Dialogs/dialogs/ImportFolderDialog.vue'));
  });
}
